import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  {
    projectResource,
    nextProjectResource,
  }: Boundaries["activateProjectResource"]["request"],
): State {
  const index = state.findIndex(
    (res) => res.projectResource.uuid === projectResource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { projectResource, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { projectResource, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  projectResource: Boundaries["activateProjectResource"]["success"],
): State {
  return state.map((res) =>
    res.projectResource.uuid === projectResource.uuid
      ? { projectResource, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { projectResource }: Boundaries["activateProjectResource"]["failure"],
): State {
  return state.map((res) =>
    res.projectResource.uuid === projectResource.uuid
      ? { projectResource, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.activateProjectResourceRequested]: handleRequest,
    [events.activateProjectResourceSucceeded]: handleSuccess,
    [events.activateProjectResourceFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
